import React from 'react';
import { Link } from 'react-router-dom';
// import ThemeToggleButton from 'shared/components/ThemeToggleButton';
import { useThemeContext } from 'shared/context/themeContext';
import {
  dark as darkColors,
  light as lightColors
} from 'shared/theme/colorTokens';

interface Props {
  isCollapsed: boolean;
  isMobile: boolean;
  toggleCollapse: () => void;
  title?: string;
  logo?: any;
}

const SidebarHeader = ({ isCollapsed, title, logo }: Props) => {
  const { theme } = useThemeContext();
  const isDark = theme === 'dark';

  return (
    <div
      className={'items-center flex w-full justify-between gap-10'}
      style={{
        background: isDark
          ? darkColors.sidebarEdgeGradient
          : lightColors.sidebarEdgeGradient,
        height: '65px',
        justifyContent: 'center'
      }}
    >
      {title ? (
        <h1
          className={
            isCollapsed
              ? 'hidden'
              : `font-black text-lg ${
                  isDark ? 'text-gray-50' : 'text-blueGray-800'
                }`
          }
        >
          {title}
        </h1>
      ) : null}
      {logo ? (
        <Link to={'/main/landing'} className="flex justify-center">
          <img
            src={logo}
            width="100px"
            className={
              'soft-transition text-xs font-black text-lg text-gray-50 cursor-pointer'
            }
          />
        </Link>
      ) : null}
      {/* {!isCollapsed ? <ThemeToggleButton /> : null} */}
    </div>
  );
};

export default SidebarHeader;
